<template>
  <div v-if="!loading" class="box">
      <!-- <img class="img" src="../../../assets/images/dynamic/bg_prize.jpg"> -->
      <div class="content" v-html="content"></div>
  </div>
  <Loading v-else :loading="loading"/>
</template>

<script>

import Loading from '../../../components/Loading'
import { getWinnerDetail } from '../../../api/api'
export default {
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      url: '',
      isPc: true,
      id: this.$route.params.id,
      content: '恭喜你获得本次活动一等奖！奖品为 华为手机 请复星通联系星小圈领取请复星通联系星小圈领取,请复星通联系星小圈领取'
    }
  },
  mounted () {
    const _this = this
    _this.loading = true
    // window.addEventListener('scroll', _this.handleScroll, true)
    _this.getDetail()
    // console.log('宽度', document.documentElement.clientWidth)
    _this.clientHeight = document.documentElement.clientHeight
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setRight({
        show: false // 控制按钮显示， true 显示， false 隐藏， 默认true
      })
    }
  },
  methods: {
    async getDetail () {
      try {
        const res = await getWinnerDetail({
          participant_id: this.id
        })
        if (res.code === 200) {
          this.content = res.data.text
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  .box {
    // position: relative;
    width: 100%;
    height: 100vh;
    font-size: 0;
    overflow-y: scroll;
    .img {
      width: 100%;
    }
    .content {
      width: 100%;
      min-height: 100%;
      font-size: 18px;
      position: absolute;
      background: url('../../../assets/images/dynamic/bg_prize.jpg') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      // top: 50%;
      // z-index: 9;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // font-size: 18px;
      // width: 70%;
      // height: 35vh;
      // margin: 0 auto;
      // padding-top: 70%;
      // -webkit-touch-callout:none;
      // -webkit-user-select:none;
      // -khtml-user-select:none;
      // -moz-user-select:none;
      // -ms-user-select:none;
      // user-select:none;
    }
  }
</style>
